/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Faq_Q4Inputs */

const en_directory_home_faq_q4 = /** @type {(inputs: Directory_Home_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I edit a listing after it goes live?`)
};

const zh_directory_home_faq_q4 = /** @type {(inputs: Directory_Home_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上线之后还能编辑产品信息吗？`)
};

/**
* | output |
* | --- |
* | "Can I edit a listing after it goes live?" |
*
* @param {Directory_Home_Faq_Q4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_faq_q4 = /** @type {((inputs?: Directory_Home_Faq_Q4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Faq_Q4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_faq_q4(inputs)
	return zh_directory_home_faq_q4(inputs)
});
export { directory_home_faq_q4 as "directory.home.faq.q4" }